export default {
  navBar: {
    '& h3': {
      color: 'white',
      fontFamily:
        "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
    },
  },
  deleteAvatar: {
    backgroundColor: '#eb4559',
  },
  cancelAvatar: {
    backgroundColor: 'teal',
  },
}
